// Lightweight diagnostic pinger for unauthenticated auth-flow steps.
// Uses sendBeacon when possible (survives navigation/redirect on mobile),
// falls back to fetch+keepalive. Never throws; best-effort only.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ENDPOINT = `${BACKEND_URL}/api/auth/client-log`;

export const clientLog = (stage, message = "", detail = {}) => {
  try {
    const payload = JSON.stringify({
      level: "info",
      stage,
      message: String(message || "").slice(0, 500),
      detail: {
        ...detail,
        url: typeof window !== "undefined" ? window.location.href : null,
        hash: typeof window !== "undefined" ? window.location.hash : null,
        ts: new Date().toISOString(),
      },
    });

    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      const blob = new Blob([payload], { type: "application/json" });
      const ok = navigator.sendBeacon(ENDPOINT, blob);
      if (ok) return;
    }

    // Fallback: fetch with keepalive so it survives redirects.
    if (typeof fetch === "function") {
      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payload,
        keepalive: true,
        credentials: "omit",
      }).catch(() => { /* swallow */ });
    }
  } catch (e) {
    /* swallow all */
  }
};
